import { render, staticRenderFns } from "./ValuesHistory.vue?vue&type=template&id=44515431&scoped=true&"
import script from "./ValuesHistory.vue?vue&type=script&lang=ts&"
export * from "./ValuesHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44515431",
  null
  
)

export default component.exports